/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets SDExternalUserApplicationStatus from api:
 * /v1/ua/sd_externaluser_application_status
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdExternaluserApplicationStatusUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_externaluser_application_status`,
    models.SDExternalUserApplicationStatus
  );
};

/**
 * Gets SDUserApplicationInfoDtls from api:
 * /v1/ua/sd_user_application_info
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdUserApplicationInfoUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_user_application_info`,
    models.SDUserApplicationInfoDtls
  );
};

export { fetchSdExternaluserApplicationStatusUtil, fetchSdUserApplicationInfoUtil };
